module.exports = __webpack_public_path__ + "static/media/002-iceberg.07ea0ef1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CareIcons/002-iceberg.png
// module id = 649
// module chunks = 0